import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';

interface ModeSwitchProps {
  mode: 'bitvavo' | 'ibkr';
  onChange: (mode: 'bitvavo' | 'ibkr') => void;
}

const ModeSwitch: React.FC<ModeSwitchProps> = ({ mode, onChange }) => (
  <ToggleButtonGroup
    value={mode}
    exclusive
    onChange={(_, v) => v && onChange(v)}
    size="small"
    sx={{ ml: 2 }}
  >
    <ToggleButton value="bitvavo" sx={{ textTransform: 'none', px: 2, fontWeight: 600 }}>
      Bitvavo
    </ToggleButton>
    <ToggleButton value="ibkr" sx={{ textTransform: 'none', px: 2, fontWeight: 600 }}>
      IBKR Options
    </ToggleButton>
  </ToggleButtonGroup>
);

export default ModeSwitch;
